import * as React from "react";
import {discntleveltype,expnamntleveltype,PrBrandType,PrBrandsIf} from '../components/Products'
import {useAuth} from './AuthContext'

import { returnBasenameUrl } from "../utils";
/*type pravcontDataType = {
 busunits: string
 rBrandsInfo:PrBrandsIf
}*/


type pravcontDataType = {
    fetched: boolean
    success: boolean    
    reply?: string
    totalcount?: number
    procstep?: number
    error?: string
    busunits?: number
    prBrandsInfo?:PrBrandsIf
}

function getInitialState():pravcontDataType {
    const pravcontextdata = sessionStorage.getItem('ksrgrb2b_pr_context')
    return pravcontextdata  ? JSON.parse(pravcontextdata) : {fetched: false, success: false}
}

async function savePrContext(prcontextData: any):Promise<any>{
    sessionStorage.setItem("ksrgrb2b_pr_context", JSON.stringify(prcontextData));
}

interface PrAvContextType {
    prContextData: pravcontDataType;
    setpravcontext: () => void ;
    clearpravcontext: () => void ;
}

let PrAvContext = React.createContext<PrAvContextType>(null!);

function PrAvProvider({ children }: { children: React.ReactNode }) {
    let [prContextData, setPravcontextData] = React.useState<pravcontDataType>(getInitialState); //  React.useState<any>(null);
    let auth = useAuth();
    console.log("PrAvProvider startup, pravcontextData=",prContextData)
    let pravData:pravcontDataType={
        fetched: false, 
        success: false,
        error: ""
    }
    React.useEffect(() => {
        sessionStorage.setItem('ksrgrb2b_pr_context', JSON.stringify(prContextData))
    },[prContextData])

    let setpravcontext = () => { 
        console.log("PrAvProvider setpravcontext, called")
        if(auth.userData === undefined || auth.userData === null ||
        auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
        auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false)
        {
            console.log("PrAvProvider setpravcontext, not authenticted")
            setPravcontextData({fetched: true, success: false})
        }
        else {
            /* bypass ajax because it is only 9999 mark for now ... */
            const ms = Date.now();
            let basename=returnBasenameUrl()
            let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
            let postdata = {
                service: "getb2bprbrandsinfo",
                usercode: auth.userData.username,	// username;
                appId: `${process.env.REACT_APP_APPID}`,    
                apikey:`${process.env.REACT_APP_API_KEY}`,
                clientid: `${auth.userData.token}`,
                tokendate: `${auth.userData.tokendate}`
            }
            console.log("PrAvProvider setpravcontext, fetching context...")

            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
                body: JSON.stringify(postdata), cache: "no-store" }
            )
            .then((response) =>  {
                if (!response.ok) {
                    console.log('PrAvProvider getb2bprbrandsinfo response not ok=',response)
                    pravData.success=false;
                    pravData.fetched=true;
                    pravData.error="Bad getb2bprbrandsinfo Response";
                    return {}
                }
                else {
                    console.log('PrAvProvider getb2bprbrandsinfo response ok=',response)
                    return response.json()
                }
            })
            .then((data:any) => {
                console.log('PrAvProvider getb2bprbrandsinfo response data=',data)
                if(data.success===undefined || data.success===null){
                    pravData.success=false;
                    pravData.fetched=true;
                    pravData.error="Bad Json Response";
                    console.log('PrAvProvider getb2bprbrandsinfo response=',"Bad Json Response")
                }
                else {
                    if(data.success===true){
                        console.log('PrAvProvider getb2bprbrandsinfo response=',"data.success===true")
                        pravData={
                            success: data.success,
                            fetched: true,
                            reply: data.reply,
                            totalcount: data.totalcount,
                            procstep: 0,
                            error: '',
                            busunits: data.busunits,
                            prBrandsInfo: data.data,
                        };
                    }
                    else {
                        console.log('PrAvProvider getb2bprbrandsinfo response=',"data.success===false")
                    }
                }
            })
            .catch((err) => {
                console.log("PrAvProvider getb2bprbrandsinfo exception=",err.message);
                pravData.success=false;
                pravData.fetched=true;
                pravData.error="PrAvProvider getb2bprbrandsinfo exception";        
            })
            .finally(() => {
                console.log("AuthProvider.signin finally: ", pravData)            
                setPravcontextData(pravData);                
            })   
            /*  
            pravData={
                success: true,
                fetched: true,
                reply: "getB2BPrBrandsinfo_reply",
                totalcount: 1,
                procstep: 0,
                error: '',
                busunits: 20,
                prBrandsInfo: {
                    "9999": {
                        markoption: 9999,
                        markcode: "ALLOTH",
                        marktitle: "Ολες οι Μάρκες εκτός Kawasaki",
                        brandavfilter: 0,
                        notbrandavfilter: "200,1000",
                        discntlevels: [ [ 0, 999999, 30 ] ],
                        "expnamntlevels": [ [ 0, 999999, 17 ]  ]
                    }
                },
            };
            setPravcontextData(pravData);
            */ 
        }
    };
    
    let clearpravcontext = () => {
        setPravcontextData({fetched: false ,success: false})
    };
    
    let value = { prContextData, setpravcontext, clearpravcontext };
    return <PrAvContext.Provider value={value}>{children}</PrAvContext.Provider>;
}

function usePrAvcontext() {
    return React.useContext(PrAvContext);
}

export {PrAvProvider, PrAvContext, usePrAvcontext}
